import React, { Component } from 'react';
import { Collapse, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, Dropdown } from 'reactstrap';
import { Link } from 'react-router-dom';
import './NavMenu.css';
import categories from './bd/categories';

export class NavMenu extends Component {
  static displayName = NavMenu.name;

  constructor(props) {
    super(props);

    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.toggleNavbarSubMenu = this.toggleSubMenu.bind(this);
    this.state = {
      collapsed: true,
      collapsedSubMenu: true
    };
  }

  toggleNavbar() {
    this.setState({
      collapsed: !this.state.collapsed
    });
  }

  toggleSubMenu() {
    this.setState({
      collapsedSubMenu: !this.state.collapsedSubMenu
    });
  }


  render() {
    let categoriesOnline = categories.filter(x => x.online);
    return (
      <header>
        <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white box-shadow" container light >
          <NavbarBrand tag={Link} to="/pt">
            <img
              src={require("./../static/images/logo8.png")}
              width="250"
              className="d-inline-block align-top logoposition"
              alt="React Bootstrap logo"
            />
          </NavbarBrand>
          <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
          <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!this.state.collapsed} navbar>
            <ul className="navbar-nav flex-grow">
              <NavItem>
                <NavLink tag={Link} className="option" to="pt/services/interior">Serviços</NavLink>
              </NavItem>
              <UncontrolledDropdown nav inNavbar className="option" >
                <DropdownToggle nav caret>
                  Produtos
                </DropdownToggle>
                <DropdownMenu>
                  {categoriesOnline.map((category, index) => {
                    return (<> <DropdownItem header>{category.categoryName}</DropdownItem>
                      {category.subCategories.filter(y => y.online).map(subCategory => (
                        <DropdownItem tag={Link} className="option" to={`pt/products/${subCategory.id}`}>{subCategory.categoryName}</DropdownItem>
                      ))}
                      {index < categoriesOnline.length - 1 ? <DropdownItem divider /> : null}  </>)
                  })}
                </DropdownMenu>
              </UncontrolledDropdown>
              <NavItem>
                <NavLink tag={Link} className="option" to="pt/contacts">Contactos</NavLink>
              </NavItem>
            </ul>
          </Collapse>
        </Navbar>
      </header>
    );
  }
}